import { selectElements } from './dom-multi-selection';
export function clickToCreateElement(container, cancellationSignal, createElement) {
    return new Promise((resolve) => {
        function onClick(event) {
            const el = createElement({ x: event.pageX, y: event.pageY });
            // should be generalize this?
            container.appendChild(el);
            cleanUp();
            resolve(el);
        }
        function onCancel() {
            cleanUp();
            resolve(null);
        }
        function cleanUp() {
            document.body.inert = false;
            cancellationSignal.removeEventListener('abort', onCancel);
            container.removeEventListener('click', onClick, { capture: true });
        }
        // should this just be applied to the container
        document.body.inert = true;
        cancellationSignal.addEventListener('abort', onCancel);
        container.addEventListener('click', onClick, { capture: true });
    });
}
export function dragToCreateElement(container, cancellationSignal, createElement, updateElement) {
    return new Promise((resolve) => {
        let el = null;
        function onPointerDown(event) {
            const point = container.folkSpace.mapPointFromParent({ x: event.pageX, y: event.pageY });
            el = createElement(point);
            container.addEventListener('pointermove', onPointerMove, { capture: true });
            container.addEventListener('pointerup', onPointerUp, { capture: true });
            // should be generalize this?
            container.appendChild(el);
        }
        function onPointerMove(event) {
            if (el === null)
                return;
            const point = container.folkSpace.mapPointFromParent({ x: event.pageX, y: event.pageY });
            updateElement(el, point);
        }
        function onPointerUp(event) {
            if (el === null)
                return;
            const point = container.folkSpace.mapPointFromParent({ x: event.pageX, y: event.pageY });
            updateElement(el, point);
            cleanUp();
            resolve(el);
        }
        function onCancel() {
            cleanUp();
            el?.remove();
            resolve(null);
        }
        function cleanUp() {
            cancellationSignal.removeEventListener('abort', onCancel);
            container.removeEventListener('pointerdown', onPointerDown, { capture: true });
            container.removeEventListener('pointermove', onPointerMove, { capture: true });
            container.removeEventListener('pointerup', onPointerUp, { capture: true });
        }
        cancellationSignal.addEventListener('abort', onCancel);
        container.addEventListener('pointerdown', onPointerDown, { capture: true });
    });
}
export async function dragToCreateShape(container, cancellationSignal, createElement) {
    const el = await dragToCreateElement(container, cancellationSignal, (point) => {
        const element = createElement();
        element.setAttribute('folk-shape', `x: ${point.x}; y: ${point.y}; width: 0; height: 0`);
        return element;
    }, (el, point) => {
        const shape = el.folkShape;
        if (shape === undefined)
            return;
        if (point.x < shape.x || point.x - shape.x < shape.x + shape.width - point.x) {
            shape.width += shape.x - point.x;
            shape.x = point.x;
        }
        else {
            shape.width = point.x - shape.x;
        }
        if (point.y < shape.y || point.y - shape.y < shape.y + shape.height - point.y) {
            shape.height += shape.y - point.y;
            shape.y = point.y;
        }
        else {
            shape.height = point.y - shape.y;
        }
    });
    return el;
}
export async function dragToCreateRegion(container, cancellationSignal) {
    return await dragToCreateShape(container, cancellationSignal, () => {
        const r = document.createElement('folk-region');
        r.setAttribute('folk-sync', '');
        return r;
    });
}
export async function clickToCreateShapes(container, cancellationSignal, completionSignal) {
    const elements = await selectElements(completionSignal, cancellationSignal);
    for (const el of elements) {
        el.setAttribute('folk-shape', '');
    }
    return elements;
}
//# sourceMappingURL=create-element.js.map